import { render, staticRenderFns } from "./consultManage.vue?vue&type=template&id=7634a698&scoped=true&"
import script from "./consultManage.vue?vue&type=script&lang=js&"
export * from "./consultManage.vue?vue&type=script&lang=js&"
import style0 from "./consultManage.vue?vue&type=style&index=0&id=7634a698&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7634a698",
  null
  
)

export default component.exports